<article class="article-your-property" [ngClass]="customClass">
  <div class="text">
    @if (title) {
    <h3 [translate]="title">{{ title }}</h3>
    } @if (description) {
    <p [translate]="description">{{ description }}</p>
    }

    <div class="text-overlay-btn">
      @if (showArrows) {
      <img
        src="../../assets/icons/arrow-left.svg"
        alt="arrow-left"
        class="arrow-left"
      />
      }

      <button class="green-btn" (click)="onButtonClick()">
        @if (buttonText) {
        <span [translate]="buttonText">{{ buttonText }}</span>
        }
      </button>

      @if (showArrows) {
      <img
        src="../../assets/icons/arrow-right.svg"
        alt="arrow-right"
        class="arrow-right"
      />
      }
    </div>
  </div>
</article>
